// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"a994ca76","152":"fc387d6c","313":"96ea1094","322":"697e73cb"}[chunkId] + ".chunk.js";
};